import { a as getDefaultExportFromCjs } from './_commonjsHelpers-357b3b4e.js';
import { r as requirePropTypes } from './index-48edd52c.js';

var propTypesExports = requirePropTypes();
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

export { PropTypes as P };
//# sourceMappingURL=index-5fd269e1.js.map
